import { required } from "@rx/annotations";
export class PageQueryViewModel{
    pageNumber:number= 1;
    pageSize:number= 10;
    sortColumnName:string= '1';
    sortOrder: string = 'Desc';
}